import { useQuery } from '@apollo/client';
import { ContactPageOutlined } from '@mui/icons-material';
import { Widget, WidgetContent, WidgetHeader, WidgetIcon, useScrollIntoView } from '@procureai/ui-mui';
import { isEmpty } from 'ramda';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';
import { CircularProgressCentered } from '~/components/CircularProgressCentered/CircularProgressCentered';
import { DataGridCustom } from '~/components/DataGridCustom';
import { useModuleContext } from '~/components/ModuleContextProvider';
import { PlaceholderWidget } from '~/components/PlaceholderWidget/PlaceholderWidget';

import { useSupplierRisksGridConfig } from './SupplierRisksWidget.dataGrid';
import { SUPPLIER_RISKS_WIDGET_QUERY } from './SupplierRisksWidget.gql';

const WIDGET_NAME = 'SupplierRisksWidget';

export const SupplierRisksWidget = () => {
  const { entityId } = useModuleContext();
  const { t } = useTranslation(I18nNamespace.riskSustainability, { keyPrefix: WIDGET_NAME });
  const [widgetRef, active] = useScrollIntoView({ hash: 'supplier-risks' });
  const { data, loading } = useQuery(SUPPLIER_RISKS_WIDGET_QUERY, { variables: { id: entityId } });
  const config = useSupplierRisksGridConfig();
  const risks = data?.cataclysm?.supplier?.risks ?? [];
  return (
    <Widget ref={widgetRef} active={active} data-intercom-target={WIDGET_NAME}>
      <WidgetHeader title={t('title')} icon={<WidgetIcon icon={<ContactPageOutlined fontSize="small" />} />} />
      <WidgetContent>
        {!isEmpty(risks) ? (
          <DataGridCustom
            rows={risks}
            columns={config.columns}
            getRowId={(row) => (row as any).id}
            pagination={true}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 5,
                },
              },
            }}
            hideFooter={false}
            pageSizeOptions={[5]}
            disableRowSelectionOnClick
          />
        ) : loading ? (
          <CircularProgressCentered sx={{ position: 'relative' }} />
        ) : (
          <PlaceholderWidget />
        )}
      </WidgetContent>
    </Widget>
  );
};
